const baseVariantShared = {
  primary: {
    color: 'hyperlink',
    fontWeight: 'strong',
    '.linkHasArrowIcon path': {
      stroke: 'coolGrey.100',
      strokeWidth: '1px',
    },
    '.linkHasCarotIcon path': {
      strokeWidth: '2px',
    },
    '&:hover, &:focus, &:active': {
      fontWeight: 'regular',
      '.linkHasArrowIcon path': {
        stroke: 'initial',
        strokeWidth: 'initial',
      },
      '.linkHasCarotIcon path': {
        strokeWidth: '1px',
      },
    },
  },
  primaryAlternate: {
    color: 'coolGrey.100',
    fontWeight: 'strong',
    '.linkHasArrowIcon path': {
      stroke: 'coolGrey.100',
      strokeWidth: '1px',
    },
    '.linkHasCarotIcon path': {
      stroke: 'coolGrey.100',
      strokeWidth: '2px',
    },
    '&:hover, &:focus, &:active': {
      fontWeight: 'regular',
      '.linkHasArrowIcon path': {
        stroke: 'initial',
        strokeWidth: 'initial',
      },
      '.linkHasCarotIcon path': {
        strokeWidth: '1px',
      },
    },
  },
  primaryInverse: {
    color: 'white',
    fontWeight: 'strong',
    '.linkHasArrowIcon path': {
      stroke: 'white',
      strokeWidth: '1px',
    },
    '.linkHasCarotIcon path': {
      stroke: 'white',
      strokeWidth: '2px',
    },
    '&:hover, &:focus, &:active': {
      fontWeight: 'regular',
      '.linkHasArrowIcon path': {
        stroke: 'initial',
        strokeWidth: 'initial',
      },
      '.linkHasCarotIcon path': {
        strokeWidth: '1px',
      },
    },
  },
  secondary: {
    color: 'hyperlink',
    fontWeight: 'regular',
    '&:hover, &:focus, &:active': {
      fontWeight: 'strong',
      '.linkHasArrowIcon path': {
        stroke: 'coolGrey.100',
        strokeWidth: '1px',
      },
      '.linkHasCarotIcon path': {
        strokeWidth: '2px',
      },
    },
  },
  secondaryAlternate: {
    color: 'coolGrey.100',
    fontWeight: 'regular',
    '&:hover, &:focus, &:active': {
      fontWeight: 'strong',
      '.linkHasArrowIcon path': {
        stroke: 'coolGrey.100',
        strokeWidth: '1px',
      },
      '.linkHasCarotIcon path': {
        strokeWidth: '2px',
      },
    },
  },
  secondaryInverse: {
    color: 'white',
    fontWeight: 'regular',
    '.linkHasCarotIcon path': {
      stroke: 'white',
      strokeWidth: '1px',
    },
    '&:hover, &:focus, &:active': {
      fontWeight: 'strong',
      '.linkHasArrowIcon path': {
        stroke: 'white',
        strokeWidth: '1px',
      },
      '.linkHasCarotIcon path': {
        strokeWidth: '2px',
      },
    },
  },
  navLink: {
    fontWeight: 'strong',
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus, &:hover': {
      textDecoration: 'none',
    },
    '&:hover': {
      color: 'primary',
    },
  },
  subNavLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '& > p': {
      '&:hover': {
        color: 'primary',
      },
      '&:active, &:focus': {
        color: 'primary',
      },
    },
  },
};

const {
  primaryAlternate,
  secondaryAlternate,
  primaryInverse,
  secondaryInverse,
  primary,
  secondary,
  navLink: navLinkShared,
  subNavLink: subNavLinkShared,
} = baseVariantShared;

const chart = {
  primary,
  primaryAlternate,
  primaryInverse,
  secondary,
  secondaryAlternate,
  secondaryInverse,
  navLink: {
    ...navLinkShared,
    margin: 0,
    '&:active, &:focus': {
      color: 'primary',
    },
  },
  subNavLink: subNavLinkShared,
};

const co = {
  primary,
  primaryAlternate,
  primaryInverse,
  secondary,
  secondaryAlternate,
  secondaryInverse,
  navLink: {
    ...navLinkShared,
    '&:active, &:focus': {
      color: 'blue.90',
    },
  },
  subNavLink: {
    ...subNavLinkShared,
    '&:active, &:focus': {
      color: 'blue.90',
      '& > span, & > p': {
        color: 'blue.90',
      },
    },
    '&:hover': {
      color: 'blue.90',
      '& > span, & > p': {
        color: 'blue.90',
      },
    },
    '& > p': {
      '&:hover': {
        color: 'blue.90',
      },
      '&:active, &:focus': {
        color: 'blue.90',
      },
    },
  },
};

const edu = {
  primaryAlternate,
  primaryInverse,
  secondaryAlternate,
  secondaryInverse,
  primary,
  secondary,
  navLink: {
    ...navLinkShared,
    '&:active, &:focus': {
      color: 'indigo.80',
    },
  },
  subNavLink: subNavLinkShared,
};

const scale = {
  primary,
  primaryAlternate,
  primaryInverse,
  secondary,
  secondaryAlternate,
  secondaryInverse,
  navLink: {
    ...navLinkShared,
    '&:active, &:focus': {
      color: 'primaryAccent',
    },
  },
  subNavLink: subNavLinkShared,
};

const spark = {
  primary,
  primaryAlternate,
  primaryInverse,
  secondary,
  secondaryAlternate,
  secondaryInverse,
  navLink: {
    ...navLinkShared,
    '&:active, &:focus': {
      color: 'red.80',
    },
  },
  subNavLink: subNavLinkShared,
};

const links = {
  products: {
    chart,
    chartblog: chart,
    co,
    edu,
    scale,
    spark,
  },
};

export type LinkVariantsType =
  | 'primary'
  | 'primaryAlternate'
  | 'primaryInverse'
  | 'secondary'
  | 'secondaryAlternate'
  | 'secondaryInverse'
  | 'navLink'
  | 'subNavLink';

export const linkVariants = Object.keys(chart) as LinkVariantsType[];

export default links;
